import { useTranslation } from 'react-i18next';

import { ChecklistColumns, OtherField } from './components';
import { getClientSignsSymptomsData } from '../../constants';
import { getClientSignsSymptomsItems } from './utils';

import type { ClientSignsSymptomsProps } from './types';

function ClientSignsSymptoms({
  data,
  errorMessage,
  hasError,
  isEditable,
  onChange,
  subtitle,
  title,
  useNewUi,
}: ClientSignsSymptomsProps) {
  const { t } = useTranslation('sessionNotes');

  return (
    <ChecklistColumns
      title={title}
      subtitle={subtitle}
      errorMessage={errorMessage}
      hasError={hasError}
      items={getClientSignsSymptomsItems(getClientSignsSymptomsData(t), data, t)}
      isEditable={isEditable}
      useNewUi={useNewUi}
      onChange={onChange}
      footer={
        <OtherField
          dataTestId="inputTypeForOtherClientSignSymptons"
          label={t('symptomsObserved.fields.other')}
          legacyLabel="Type for other"
          legacyPlaceholder="Type for other"
          placeholder="Explain other"
          value={data.other}
          disabled={!isEditable}
          useNewUi={useNewUi}
          onChange={onChange}
        />
      }
    />
  );
}

export default ClientSignsSymptoms;
